import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useNavigationType, useParams } from "react-router-dom";
import Select, { StylesConfig } from "react-select";
import { ThailandAddressTypeahead, ThailandAddressValue } from "react-thailand-address-typeahead";
import DataTableLayout from "layouts/DatatableLayout";
import { Formik, Field, FieldArray } from "formik";
import * as yup from "yup";
import Modal from "react-bootstrap/Modal";
import { nanoid } from "nanoid";
import DownloadExcel from "utils/DownloadExcel";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { getAllGroupOfSupplier } from "../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import { getAllMstBusinessType } from "../../redux/handlers/master/getAllMstBusinessType.handler";
import { defaultOption } from "constants/ui/options";
import { base64ToBlob, getEmpFullNameTH, mapMstPrefixToOptions, mapMstToOptions } from "utils/HelperFunction";
import { getAllMstBusinessCategory } from "../../redux/handlers/master/getAllMstBusinessCategory.handler";
import { getAllMstPrefix } from "../../redux/handlers/master/getAllMstPrefix.handler";
import { getAllMstCompanyPrefix } from "../../redux/handlers/master/getAllMstCompanyPrefix.handler";
import { getAllMstPaymentTerm } from "../../redux/handlers/master/getAllMstPaymentTerm.handler";
import { getAllMstPaymentMethod } from "../../redux/handlers/master/getAllMstPaymentMethod.handler";
import { getAllMstBank } from "../../redux/handlers/master/getAllMstBank.handler";
import { getAllMstSupplierDoc } from "../../redux/handlers/master/getAllMstSupplierDoc.handler";
import { suplierData, suplierInitData } from "mocks/supplierData";
import moment from "moment";
import { clearCreateSupplierInformation, createSupplierInformation } from "../../redux/handlers/logic/createSupplierInformation.handler";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { getSupplierInformationById } from "../../redux/handlers/logic/getSupplierInformationById.handler";
import { getFileName, getFullUrlPath } from "utils/HandleFileFunction";
import { clearUpdateSupplierInformation, updateSupplierInformation } from "../../redux/handlers/logic/updateSupplierInformation.handler";
import { mobilePhoneRegExp } from "utils/HelperRegex";
import { getAllMstPriceCategory } from "../../redux/handlers/master/getAllMstPriceCategory.handler";
import { getAllMstPaymentType } from "../../redux/handlers/master/getAllMstPaymentType.handler";
export function DistributorCreate() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(1), 2), tab = _useState[0], setTab = _useState[1];
    var _useState1 = _sliced_to_array(useState("create"), 2), mode = _useState1[0], setMode = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), formdisabled = _useState2[0], setFormdisabled = _useState2[1];
    var supID = useParams().supID;
    var _useState3 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState3[0], setModalsuccess = _useState3[1];
    var _useState4 = _sliced_to_array(useState(suplierInitData), 2), formdata = _useState4[0], setFormdata = _useState4[1];
    var getSupplierInformationByIdReducer = useAppSelector(function(state) {
        return state.getSupplierInformationByIdReducer;
    });
    var getData = function() {
        dispatch(getSupplierInformationById(supID, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var createSupplierInformationReducer = useAppSelector(function(state) {
        return state.createSupplierInformationReducer;
    });
    var updateSupplierInformationReducer = useAppSelector(function(state) {
        return state.updateSupplierInformationReducer;
    });
    useEffect(function() {
        setIsLoading(createSupplierInformationReducer.isFetching);
        if (createSupplierInformationReducer.data && !createSupplierInformationReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "เพิ่มสำเร็จ",
                    direction: ""
                });
            });
            var createdData = createSupplierInformationReducer.data.data;
            dispatch(clearCreateSupplierInformation());
            var id = createdData && createdData.id ? createdData.id : null;
            if (id) {
                navigate("/distributor/edit/".concat(id));
            } else {
                navigate("/distributor");
            }
        }
    }, [
        createSupplierInformationReducer
    ]);
    useEffect(function() {
        setIsLoading(updateSupplierInformationReducer.isFetching);
        if (updateSupplierInformationReducer.data && !updateSupplierInformationReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "แก้ไขสำเร็จ",
                    direction: ""
                });
            });
            setFormdisabled(true);
            dispatch(clearUpdateSupplierInformation());
            dispatch(getSupplierInformationById(supID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        updateSupplierInformationReducer
    ]);
    useEffect(function() {
        setIsLoading(getSupplierInformationByIdReducer.isFetching);
        if (getSupplierInformationByIdReducer.data && !getSupplierInformationByIdReducer.isError) {
            var datas = getSupplierInformationByIdReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            if (dataWithReplacements.dimMstCompanyPrefix) {
                dataWithReplacements.businessPrefix = dataWithReplacements.dimMstCompanyPrefix.prefix;
                dataWithReplacements.businessSuffix = dataWithReplacements.dimMstCompanyPrefix.suffix;
            }
            setFormdata(dataWithReplacements);
            setFormdisabled(true);
        }
    }, [
        getSupplierInformationByIdReducer
    ]);
    useEffect(function() {
        if (!supID) {
            setTab(1);
            setFormdata(suplierInitData);
            setFormdisabled(false);
        }
        if (supID) {
            getData();
        }
    }, [
        supID
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดซื้อ"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "ผู้จำหน่าย",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 tc-7  mb-4 lh-1 py-2",
                        children: "เพิ่มผู้จำหน่าย "
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-4 mt-3 py-2",
                        children: [
                            /*#__PURE__*/ _jsxs(Button, {
                                className: "btn-category px-4 ".concat(tab == 1 ? "active" : ""),
                                onClick: function() {
                                    return setTab(1);
                                },
                                children: [
                                    "ข้อมูลผู้จำหน่าย",
                                    " "
                                ]
                            }),
                            supID && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsxs(Button, {
                                        className: "btn-category px-4 ".concat(tab == 2 ? "active" : ""),
                                        onClick: function() {
                                            return setTab(2);
                                        },
                                        children: [
                                            "ข้อมูลผู้ติดต่อ",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Button, {
                                        className: "btn-category px-4 ".concat(tab == 3 ? "active" : ""),
                                        onClick: function() {
                                            return setTab(3);
                                        },
                                        children: [
                                            "บัญชีและการเงิน",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Button, {
                                        className: "btn-category px-4 ".concat(tab == 4 ? "active" : ""),
                                        onClick: function() {
                                            return setTab(4);
                                        },
                                        children: [
                                            "เอกสารร้าน",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Button, {
                                        className: "btn-category px-4 ".concat(tab == 5 ? "active" : ""),
                                        onClick: function() {
                                            return setTab(5);
                                        },
                                        children: [
                                            "เชื่อมต่อภายนอก",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Button, {
                                        className: "btn-category px-4 ".concat(tab == 6 ? "active" : ""),
                                        onClick: function() {
                                            return setTab(6);
                                        },
                                        children: [
                                            "ภาพรวม",
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "card card-st-1",
                        children: [
                            tab == 1 ? /*#__PURE__*/ _jsx(Distributor, {
                                mode: mode,
                                setTab: setTab,
                                distributorData: formdata,
                                setDistributorData: setFormdata,
                                formdisabled: formdisabled,
                                setFormdisabled: setFormdisabled,
                                resetData: getData
                            }) : "",
                            tab == 2 ? /*#__PURE__*/ _jsx(Contact, {
                                mode: mode,
                                setTab: setTab,
                                contactData: formdata,
                                setContactData: setFormdata,
                                formdisabled: formdisabled,
                                setFormdisabled: setFormdisabled,
                                resetData: getData
                            }) : "",
                            tab == 4 ? /*#__PURE__*/ _jsx(Document, {
                                mode: mode,
                                setTab: setTab,
                                formdata: formdata,
                                setFormdata: setFormdata,
                                formdisabled: formdisabled,
                                setFormdisabled: setFormdisabled,
                                resetData: getData
                            }) : "",
                            tab == 5 ? /*#__PURE__*/ _jsx(Line, {
                                mode: mode,
                                setTab: setTab,
                                connectData: formdata,
                                setConnectData: setFormdata,
                                formdisabled: formdisabled,
                                setFormdisabled: setFormdisabled,
                                resetData: getData
                            }) : ""
                        ]
                    }),
                    tab == 3 ? /*#__PURE__*/ _jsx(Account, {
                        mode: mode,
                        setTab: setTab,
                        accountData: formdata,
                        setAccountData: setFormdata,
                        formdisabled: formdisabled,
                        setFormdisabled: setFormdisabled,
                        resetData: getData
                    }) : "",
                    tab == 6 ? /*#__PURE__*/ _jsx(Overview, {
                        mode: mode,
                        setTab: setTab,
                        formdisabled: formdisabled,
                        setFormdisabled: setFormdisabled
                    }) : ""
                ]
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
}
var Distributor = function(_param) {
    var distributorData = _param.distributorData, setDistributorData = _param.setDistributorData, props = _object_without_properties(_param, [
        "distributorData",
        "setDistributorData"
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var supID = useParams().supID;
    var _useState = _sliced_to_array(useState(ThailandAddressValue.fromDatasourceItem({
        d: "",
        p: "",
        po: "",
        s: ""
    })), 2), address = _useState[0], setAddress = _useState[1];
    var _useState1 = _sliced_to_array(useState(ThailandAddressValue.fromDatasourceItem({
        d: "",
        p: "",
        po: "",
        s: ""
    })), 2), address2 = _useState1[0], setAddress2 = _useState1[1];
    var schema = yup.object().shape({
        tax_identification_number: yup.string().required(),
        dim_mst_prefix_id: yup.string().when("dim_mst_business_type_id", {
            is: function(v) {
                return v == 1;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        first_name: yup.string().when("dim_mst_business_type_id", {
            is: function(v) {
                return v == 1;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        last_name: yup.string().when("dim_mst_business_type_id", {
            is: function(v) {
                return v == 1;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        dim_mst_company_prefix_id: yup.string().when("dim_mst_business_type_id", {
            is: function(v) {
                return v == 2;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        company_name: yup.string().when("dim_mst_business_type_id", {
            is: function(v) {
                return v == 2;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        // businessSuffix: yup.string().when("dim_mst_business_type_id", {
        //   is: (v) => v == 2,
        //   then: (schema) => schema.required(),
        // }),
        company_branch_code: yup.string().when("dim_mst_business_type_id", {
            is: function(v) {
                return v == 2;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        company_branch_name: yup.string(),
        initials: yup.string(),
        code: yup.string(),
        company_address: yup.string().required(),
        company_sub_district: yup.string().required(),
        company_district: yup.string().required(),
        company_province: yup.string().required(),
        company_postal_code: yup.string().required(),
        company_phone_number: yup.string(),
        company_mobile_phone_number: yup.string().matches(mobilePhoneRegExp, "mobile phone number is not valid"),
        company_email: yup.string(),
        company_website: yup.string(),
        doc_delivery_address: yup.string().required(),
        doc_delivery_sub_district: yup.string().required(),
        doc_delivery_district: yup.string().required(),
        doc_delivery_province: yup.string().required(),
        doc_delivery_postal_code: yup.string().required(),
        doc_delivery_phone_number: yup.string(),
        doc_delivery_mobile_phone_number: yup.string().matches(mobilePhoneRegExp, "mobile phone number is not valid"),
        doc_delivery_email: yup.string(),
        dim_group_of_supplier_id: yup.string().required()
    });
    var _useState2 = _sliced_to_array(useState(false), 2), modalShow = _useState2[0], setModalShow = _useState2[1];
    var loadAllMsts = function() {
        dispatch(getAllMstBusinessType());
        dispatch(getAllMstPrefix());
        dispatch(getAllGroupOfSupplier());
        dispatch(getAllMstBusinessCategory());
        dispatch(getAllMstCompanyPrefix());
    };
    var _useState3 = _sliced_to_array(useState([]), 2), ratioBusinessTypes = _useState3[0], setRatioBusinessTypes = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), ratioBusinessCategories = _useState4[0], setRatioBusinessCategories = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), optionsMstPrefix = _useState5[0], setOptionsMstPrefix = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState6[0], setOptionsGroupOfSuplier = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), optionsMstCompanyPrefix = _useState7[0], setOptionsMstCompanyPrefix = _useState7[1];
    var getAllMstBusinessTypeReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessTypeReducer;
    });
    var getAllMstBusinessCategoryReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessCategoryReducer;
    });
    var getAllMstPrefixReducer = useAppSelector(function(state) {
        return state.getAllMstPrefixReducer;
    });
    var getAllGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.getAllGroupOfSupplierReducer;
    });
    var getAllMstCompanyPrefixReducer = useAppSelector(function(state) {
        return state.getAllMstCompanyPrefixReducer;
    });
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstBusinessTypeReducer.isFetching || getAllGroupOfSupplierReducer.isFetching || getAllMstBusinessCategoryReducer.isFetching || getAllMstPrefixReducer.isFetching || getAllMstCompanyPrefixReducer.isFetching);
        if (getAllMstBusinessTypeReducer.data) {
            setRatioBusinessTypes(getAllMstBusinessTypeReducer.data.data);
        }
        if (getAllMstBusinessCategoryReducer.data) {
            setRatioBusinessCategories(getAllMstBusinessCategoryReducer.data.data);
        }
        if (getAllGroupOfSupplierReducer.data) {
            var options = mapMstToOptions(getAllGroupOfSupplierReducer.data.data);
            setOptionsGroupOfSuplier(_to_consumable_array(options));
        }
        if (getAllMstPrefixReducer.data) {
            var options1 = mapMstToOptions(getAllMstPrefixReducer.data.data);
            setOptionsMstPrefix(_to_consumable_array(options1));
        }
        if (getAllMstCompanyPrefixReducer.data) {
            var options2 = mapMstPrefixToOptions(getAllMstCompanyPrefixReducer.data.data);
            setOptionsMstCompanyPrefix(_to_consumable_array(options2));
        }
    }, [
        getAllMstBusinessTypeReducer,
        getAllGroupOfSupplierReducer,
        getAllMstBusinessCategoryReducer,
        getAllMstCompanyPrefixReducer,
        getAllMstPrefixReducer
    ]);
    useEffect(function() {
        if (supID) {
            setAddress({
                district: distributorData.company_sub_district,
                subdistrict: distributorData.company_district,
                province: distributorData.company_province,
                postalCode: distributorData.company_postal_code
            });
            setAddress2({
                district: distributorData.doc_delivery_sub_district,
                subdistrict: distributorData.doc_delivery_district,
                province: distributorData.doc_delivery_province,
                postalCode: distributorData.doc_delivery_postal_code
            });
        }
    }, [
        distributorData
    ]);
    return /*#__PURE__*/ _jsx(Formik, {
        enableReinitialize: true,
        initialValues: distributorData,
        validationSchema: schema,
        onSubmit: function(values) {
            var _loop = function(key) {
                if (Object.hasOwnProperty.call(values, key)) {
                    var value = values[key];
                    if (key === "img_file" && typeof value === "string" && value) {
                        var blob = base64ToBlob(value);
                        formdataPayload.append(key, blob, "img_file.jpg");
                    } else if (Array.isArray(value)) {
                        value.forEach(function(item) {
                            return formdataPayload.append(key, item);
                        });
                    } else if (value !== undefined) {
                        formdataPayload.append(key, value);
                    }
                }
            };
            var formdataPayload = new FormData();
            for(var key in values)_loop(key);
            // for (let pair of formdataPayload.entries()) {
            //   console.log(`${pair[0]}, ${pair[1].name ?? pair[1]}`);
            // }
            if (supID) {
                dispatch(updateSupplierInformation(supID, formdataPayload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            } else {
                dispatch(createSupplierInformation(formdataPayload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        },
        children: function(param) /*#__PURE__*/ {
            var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, resetForm = param.resetForm;
            var _values_businessPrefix, _values_businessSuffix;
            return _jsxs(Form, {
                noValidate: true,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ _jsx("fieldset", {
                        disabled: props.formdisabled,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card-body px-xl-4 py-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-20 fw-bold tc-5 mb-2",
                                        children: "ข้อมูลสาขา"
                                    }),
                                    /*#__PURE__*/ _jsx(Imageupload, {
                                        isUpdate: supID != undefined,
                                        setFieldValue: setFieldValue,
                                        values: values
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "pt-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row gx-xl-4 items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-3",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "mb-4 ",
                                                            children: ratioBusinessTypes.map(function(value, index) {
                                                                return /*#__PURE__*/ _jsx(Form.Check, {
                                                                    inline: true,
                                                                    label: value.name,
                                                                    name: "dim_mst_business_type_id",
                                                                    type: "radio",
                                                                    id: "p-radio-1",
                                                                    className: "form-check-st-2 tc-7 mt-0",
                                                                    isInvalid: !!errors.dim_mst_business_type_id,
                                                                    checked: values.dim_mst_business_type_id === value.id,
                                                                    onChange: function() {
                                                                        setFieldValue("dim_mst_business_type_id", value.id);
                                                                    }
                                                                }, "business-type-".concat(index + 1));
                                                            })
                                                        }, "p-radio")
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-4",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "รหัสผู้จัดจำหน่าย"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "code",
                                                                    className: "form-control",
                                                                    placeholder: "เลขที่",
                                                                    value: values.code,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.code
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-5"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-4 d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn btn-st-3 me-3 px-2",
                                                                onClick: function() {
                                                                    return setModalShow(true);
                                                                },
                                                                children: "ค้นหาจาก TAX ID"
                                                            }),
                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 flex-fill  pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "เลขที่ประจำตัวผู้เสียภาษี"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "number",
                                                                        name: "tax_identification_number",
                                                                        className: "form-control",
                                                                        placeholder: "เลขที่ประจำตัวผู้เสียภาษี",
                                                                        value: values.tax_identification_number,
                                                                        onChange: handleChange,
                                                                        isInvalid: !!errors.tax_identification_number,
                                                                        maxLength: 13
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    values.dim_mst_business_type_id === 2 ? /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-6",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "mb-3 mt-4",
                                                            children: ratioBusinessCategories.map(function(value, index) {
                                                                return /*#__PURE__*/ _jsx(Form.Check, {
                                                                    inline: true,
                                                                    label: value.name,
                                                                    name: "dim_mst_business_category_id",
                                                                    type: "radio",
                                                                    id: "bt-radio-2",
                                                                    className: "form-check-st-2 tc-7",
                                                                    isInvalid: !!errors.dim_mst_business_category_id,
                                                                    checked: values.dim_mst_business_category_id === value.id,
                                                                    onChange: function() {
                                                                        setFieldValue("dim_mst_business_category_id", value.id);
                                                                        if (value.id == 1) {
                                                                            setFieldValue("company_branch_name", "สำนักงานใหญ่");
                                                                        } else {
                                                                            setFieldValue("company_branch_name", "");
                                                                        }
                                                                    }
                                                                }, "ratioBusinessCategories-".concat(index));
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "คำนำหน้าชื่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "dim_mst_prefix_id",
                                                                            onChange: function(e) {
                                                                                setFieldValue("dim_mst_prefix_id", e.value);
                                                                            },
                                                                            className: !!errors.dim_mst_prefix_id ? "w-100 select-st-1 isInvalid " : "w-100 select-st-1",
                                                                            options: optionsMstPrefix,
                                                                            placeholder: "เลือกคำนำหน้าชื่อ",
                                                                            isInvalid: !!errors.dim_mst_prefix_id,
                                                                            value: optionsMstPrefix.filter(function(item) {
                                                                                return item.value === values.dim_mst_prefix_id;
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ชื่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "first_name",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกชื่อ",
                                                                            value: values.first_name,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.first_name
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "นามสกุล"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "last_name",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกนามสกุล",
                                                                            value: values.last_name,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.last_name
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ชื่อย่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "initials",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกชื่อย่อ",
                                                                            value: values.initials,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.initials
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-20 fw-bold tc-5 my-4",
                                                children: "ที่อยู่บริษัท"
                                            }),
                                            /*#__PURE__*/ _jsxs(ThailandAddressTypeahead, {
                                                value: address,
                                                onValueChange: function(val) {
                                                    setAddress(val);
                                                    setFieldValue("company_sub_district", val.subdistrict);
                                                    setFieldValue("company_district", val.district);
                                                    setFieldValue("company_province", val.province);
                                                    setFieldValue("company_postal_code", val.postalCode);
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            values.dim_mst_business_type_id === 2 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-2",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ประเภท"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                    as: "select",
                                                                                    name: "dim_mst_company_prefix_id",
                                                                                    onChange: function(e) {
                                                                                        setFieldValue("dim_mst_company_prefix_id", e.value);
                                                                                        var item = optionsMstCompanyPrefix.find(function(item) {
                                                                                            return item.value === e.value;
                                                                                        });
                                                                                        setFieldValue("dim_mst_company_prefix_id", item.value);
                                                                                        var _item_prefix;
                                                                                        setFieldValue("businessPrefix", (_item_prefix = item.prefix) !== null && _item_prefix !== void 0 ? _item_prefix : "-");
                                                                                        var _item_suffix;
                                                                                        setFieldValue("businessSuffix", (_item_suffix = item.suffix) !== null && _item_suffix !== void 0 ? _item_suffix : "-");
                                                                                    },
                                                                                    className: !!errors.dim_mst_company_prefix_id ? "w-100 select-st-1 isInvalid " : "w-100 select-st-1",
                                                                                    options: optionsMstCompanyPrefix,
                                                                                    placeholder: "ประเภท",
                                                                                    isInvalid: !!errors.dim_mst_company_prefix_id,
                                                                                    value: optionsMstCompanyPrefix.filter(function(item) {
                                                                                        return item.value === values.dim_mst_company_prefix_id;
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-2",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "คำนำหน้า"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "businessPrefix",
                                                                                    className: "form-control",
                                                                                    placeholder: "-",
                                                                                    value: (_values_businessPrefix = values.businessPrefix) !== null && _values_businessPrefix !== void 0 ? _values_businessPrefix : "-",
                                                                                    onChange: handleChange,
                                                                                    isValid: touched.businessPrefix && !errors.businessPrefix,
                                                                                    isInvalid: !!errors.businessPrefix,
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-2",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ชื่อบริษัท"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "company_name",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: values.company_name,
                                                                                    onChange: handleChange,
                                                                                    isValid: touched.company_name && !errors.company_name,
                                                                                    isInvalid: !!errors.company_name
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-1",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "คำลงท้าย"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "businessSuffix",
                                                                                    className: "form-control",
                                                                                    placeholder: "-",
                                                                                    value: (_values_businessSuffix = values.businessSuffix) !== null && _values_businessSuffix !== void 0 ? _values_businessSuffix : "-",
                                                                                    onChange: handleChange,
                                                                                    isValid: touched.businessSuffix && !errors.businessSuffix,
                                                                                    isInvalid: !!errors.businessSuffix,
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-2",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "รหัสสาขา ( VAT CODE )"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "company_branch_code",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: values.company_branch_code,
                                                                                    onChange: handleChange,
                                                                                    isValid: touched.company_branch_code && !errors.company_branch_code,
                                                                                    isInvalid: !!errors.company_branch_code
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-2",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ชื่อสาขา"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "company_branch_name",
                                                                                    className: "form-control",
                                                                                    placeholder: "",
                                                                                    value: values.company_branch_name,
                                                                                    onChange: handleChange,
                                                                                    isValid: touched.company_branch_name && !errors.company_branch_name,
                                                                                    isInvalid: !!errors.company_branch_name
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-1",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ชื่อย่อ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "initials",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกชื่อย่อ",
                                                                                    value: values.initials,
                                                                                    onChange: handleChange,
                                                                                    isInvalid: !!errors.initials
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }) : "",
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ที่อยู่"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "company_address",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกที่อยู่",
                                                                            value: values.company_address,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.company_address
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "แขวง/ตำบล"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(ThailandAddressTypeahead.SubdistrictInput, {
                                                                            type: "text",
                                                                            className: "form-control ".concat(values.company_sub_district ? "" : !!errors.company_sub_district ? "is-invalid" : ""),
                                                                            placeholder: "กรอก แขวง/ตำบล",
                                                                            name: "company_sub_district",
                                                                            value: values.company_sub_district
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อำเภอ/เขต"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(ThailandAddressTypeahead.DistrictInput, {
                                                                            type: "text",
                                                                            className: "form-control ".concat(values.company_district ? "" : !!errors.company_district ? "is-invalid" : ""),
                                                                            placeholder: "กรอก อำเภอ/เขต",
                                                                            name: "company_district",
                                                                            value: values.company_district
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "จังหวัด"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(ThailandAddressTypeahead.ProvinceInput, {
                                                                            type: "text",
                                                                            className: "form-control ".concat(values.company_province ? "" : !!errors.company_province ? "is-invalid" : ""),
                                                                            placeholder: "กรอกจังหวัด",
                                                                            name: "company_province",
                                                                            value: values.company_province
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "รหัสไปรษณีย์"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(ThailandAddressTypeahead.PostalCodeInput, {
                                                                            type: "text",
                                                                            className: "form-control ".concat(values.company_postal_code ? "" : !!errors.company_postal_code ? "is-invalid" : ""),
                                                                            placeholder: "กรอกรหัสไปรษณีย์",
                                                                            name: "company_postal_code",
                                                                            value: values.company_postal_code
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 ",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3  pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เบอร์โทรศัพท์"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "company_phone_number",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกเบอร์โทรศัพท์",
                                                                            value: values.company_phone_number,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.company_phone_number
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 ",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3  pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เบอร์มือถือ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "company_mobile_phone_number",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกเบอร์มือถือ",
                                                                            value: values.company_mobile_phone_number,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.company_mobile_phone_number
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 ",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3  pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อีเมล"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "email",
                                                                            name: "company_email",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกอีเมล",
                                                                            value: values.company_email,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.company_email
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 ",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3  pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เว็บไซต์"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "company_website",
                                                                            className: "form-control",
                                                                            placeholder: "HTTP:// ",
                                                                            value: values.company_website,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.company_website
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(ThailandAddressTypeahead.Suggestion, {
                                                        containerProps: {
                                                            className: "suggestion-container"
                                                        },
                                                        optionItemProps: {
                                                            className: "suggestion-option"
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex align-items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-20 fw-bold tc-5 my-4",
                                                        children: "ที่อยู่จัดส่งเอกสาร"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "button",
                                                        onClick: function() {
                                                            setAddress2(address);
                                                            setFieldValue("doc_delivery_sub_district", address.subdistrict);
                                                            setFieldValue("doc_delivery_address", values.company_address);
                                                            setFieldValue("doc_delivery_district", address.district);
                                                            setFieldValue("doc_delivery_province", address.province);
                                                            setFieldValue("doc_delivery_postal_code", address.postalCode);
                                                            setFieldValue("doc_delivery_phone_number", values.company_phone_number);
                                                            setFieldValue("doc_delivery_mobile_phone_number", values.company_mobile_phone_number);
                                                            setFieldValue("doc_delivery_email", values.company_email);
                                                        },
                                                        className: "btn-st-3",
                                                        style: {
                                                            height: "100%"
                                                        },
                                                        children: "คัดลอกที่อยู่"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ThailandAddressTypeahead, {
                                                value: address2,
                                                onValueChange: function(val) {
                                                    setAddress2(val);
                                                    setFieldValue("doc_delivery_sub_district", val.subdistrict);
                                                    setFieldValue("doc_delivery_district", val.district);
                                                    setFieldValue("doc_delivery_province", val.province);
                                                    setFieldValue("doc_delivery_postal_code", val.postalCode);
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ที่อยู่"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "doc_delivery_address",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกที่อยู่",
                                                                            value: values.doc_delivery_address,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.doc_delivery_address
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "แขวง/ตำบล"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(ThailandAddressTypeahead.SubdistrictInput, {
                                                                            type: "text",
                                                                            className: "form-control ".concat(values.doc_delivery_sub_district ? "" : !!errors.doc_delivery_sub_district ? "is-invalid" : ""),
                                                                            placeholder: "กรอก แขวง/ตำบล",
                                                                            name: "doc_delivery_sub_district",
                                                                            value: values.doc_delivery_sub_district
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อำเภอ/เขต"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(ThailandAddressTypeahead.DistrictInput, {
                                                                            type: "text",
                                                                            className: "form-control ".concat(values.doc_delivery_district ? "" : !!errors.doc_delivery_district ? "is-invalid" : ""),
                                                                            placeholder: "กรอก อำเภอ/เขต",
                                                                            name: "doc_delivery_district",
                                                                            value: values.doc_delivery_district
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "จังหวัด"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(ThailandAddressTypeahead.ProvinceInput, {
                                                                            type: "text",
                                                                            className: "form-control ".concat(values.doc_delivery_province ? "" : !!errors.doc_delivery_province ? "is-invalid" : ""),
                                                                            placeholder: "กรอกจังหวัด",
                                                                            name: "doc_delivery_province",
                                                                            value: values.doc_delivery_province
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "รหัสไปรษณีย์"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(ThailandAddressTypeahead.PostalCodeInput, {
                                                                            type: "text",
                                                                            className: "form-control ".concat(values.doc_delivery_postal_code ? "" : !!errors.doc_delivery_postal_code ? "is-invalid" : ""),
                                                                            placeholder: "กรอกรหัสไปรษณีย์",
                                                                            name: "doc_delivery_postal_code",
                                                                            value: values.doc_delivery_postal_code
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 ",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3  pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เบอร์โทรศัพท์"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "doc_delivery_phone_number",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกเบอร์โทรศัพท์",
                                                                            value: values.doc_delivery_phone_number,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.doc_delivery_phone_number
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 ",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3  pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เบอร์มือถือ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "doc_delivery_mobile_phone_number",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกเบอร์มือถือ",
                                                                            value: values.doc_delivery_mobile_phone_number,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.doc_delivery_mobile_phone_number
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 ",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3  pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อีเมล"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "email",
                                                                            name: "doc_delivery_email",
                                                                            className: "form-control",
                                                                            placeholder: "กรอกอีเมล",
                                                                            value: values.doc_delivery_email,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.doc_delivery_email
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 ",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "กลุ่มผู้จัดจำหน่าย"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "dim_group_of_supplier_id",
                                                                            onChange: function(e) {
                                                                                setFieldValue("dim_group_of_supplier_id", e.value);
                                                                            },
                                                                            className: !!errors.dim_group_of_supplier_id ? "w-100 select-st-1 isInvalid " : "w-100 select-st-1",
                                                                            options: optionsGroupOfSuplier,
                                                                            placeholder: "เลือกกลุ่มผู้จัดจำหน่าย",
                                                                            value: optionsGroupOfSuplier.filter(function(item) {
                                                                                return item.value === values.dim_group_of_supplier_id;
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(ThailandAddressTypeahead.Suggestion, {
                                                        containerProps: {
                                                            className: "suggestion-container"
                                                        },
                                                        optionItemProps: {
                                                            className: "suggestion-option"
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "วันที่สร้าง"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "created_at",
                                                                    className: "form-control",
                                                                    placeholder: "-",
                                                                    value: values.created_at ? moment(values.end_date).format("DD/MM/YYYY") : "",
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.created_at,
                                                                    disabled: true,
                                                                    readOnly: true
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "ผู้สร้าง"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "userCreate",
                                                                    className: "form-control",
                                                                    placeholder: "-",
                                                                    value: getEmpFullNameTH(values.createdUser),
                                                                    // onChange={handleChange}
                                                                    // isInvalid={!!errors.userCreate}
                                                                    disabled: true,
                                                                    readOnly: true
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 ",
                                                                children: "สถานะ"
                                                            }),
                                                            [
                                                                "radio"
                                                            ].map(function(type) {
                                                                return /*#__PURE__*/ _jsxs("div", {
                                                                    className: "mb-4 ",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Check, {
                                                                            inline: true,
                                                                            label: "เปิดใช้งาน",
                                                                            name: "is_active",
                                                                            type: type,
                                                                            id: "s-".concat(type, "-1"),
                                                                            className: "form-check-st-2 tc-7 mt-0",
                                                                            isInvalid: !!errors.is_active,
                                                                            checked: values.is_active == 1,
                                                                            onChange: function() {
                                                                                setFieldValue("is_active", 1);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Check, {
                                                                            inline: true,
                                                                            label: "ปิดใช้งาน",
                                                                            name: "is_active",
                                                                            type: type,
                                                                            id: "s-".concat(type, "-2"),
                                                                            className: "form-check-st-2 tc-7  mt-0",
                                                                            isInvalid: !!errors.is_active,
                                                                            checked: values.is_active == 0,
                                                                            onChange: function() {
                                                                                setFieldValue("is_active", 0);
                                                                            }
                                                                        })
                                                                    ]
                                                                }, "s-".concat(type));
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-end pb-5 pe-3",
                        children: props.formdisabled === true ? /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-3",
                            onClick: function() {
                                props.setFormdisabled(false);
                            },
                            children: "แก้ไข"
                        }) : /*#__PURE__*/ _jsxs("div", {
                            className: "text-end pt-3 btn-group-control",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function() {
                                        props.resetData();
                                        resetForm();
                                        props.setFormdisabled(true);
                                    },
                                    type: "button",
                                    className: "btn-st-5 me-3",
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(TaxIDModal, {
                        show: modalShow,
                        onHide: function() {
                            return setModalShow(false);
                        },
                        setDistributorData: setDistributorData,
                        distributorData: distributorData
                    })
                ]
            });
        }
    });
};
var Contact = function(_param) {
    var contactData = _param.contactData, setContactData = _param.setContactData, props = _object_without_properties(_param, [
        "contactData",
        "setContactData"
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var supID = useParams().supID;
    var schema = yup.object().shape({
        main_contact_first_name: yup.string(),
        main_contact_last_name: yup.string(),
        main_contact_nick_name: yup.string(),
        main_contact_email: yup.string().email("Invalid email"),
        main_contact_position: yup.string(),
        main_contact_phone_number: yup.string(),
        main_contact_mobile_phone_number: yup.string().matches(mobilePhoneRegExp, "mobile phone number is not valid"),
        alternate_contact_first_name: yup.string(),
        alternate_contact_last_name: yup.string(),
        alternate_contact_nick_name: yup.string(),
        alternate_contact_email: yup.string().email("Invalid email"),
        alternate_contact_position: yup.string(),
        alternate_contact_phone_number: yup.string(),
        alternate_contact_mobile_phone_number: yup.string().matches(mobilePhoneRegExp, "mobile phone number is not valid")
    });
    // const [contactData, setContactData] = useState(suplierData);
    return /*#__PURE__*/ _jsx(Formik, {
        enableReinitialize: true,
        initialValues: contactData,
        validationSchema: schema,
        onSubmit: function(values) {
            var _loop = function(key) {
                if (Object.hasOwnProperty.call(values, key)) {
                    var value = values[key];
                    if (Array.isArray(value)) {
                        value.forEach(function(item) {
                            return formdataPayload.append(key, item);
                        });
                    } else if (value !== undefined) {
                        formdataPayload.append(key, value);
                    }
                }
            };
            // props.setTab(3);
            var formdataPayload = new FormData();
            for(var key in values)_loop(key);
            // for (let pair of formdataPayload.entries()) {
            //   console.log(`${pair[0]}, ${pair[1].name ?? pair[1]}`);
            // }
            if (supID) {
                dispatch(updateSupplierInformation(supID, formdataPayload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        },
        children: function(param) {
            var handleSubmit = param.handleSubmit, handleChange = param.handleChange, errors = param.errors, values = param.values, resetForm = param.resetForm;
            return /*#__PURE__*/ _jsxs(Form, {
                noValidate: true,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ _jsx("fieldset", {
                        disabled: props.formdisabled,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card-body px-xl-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "py-3",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-20 fw-bold tc-5 mb-3",
                                                children: "ผู้ติดต่อหลัก"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row gx-xl-4",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "ชื่อ"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "main_contact_first_name",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกชื่อ",
                                                                    value: values.main_contact_first_name,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.main_contact_first_name
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "นามสกุล"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "main_contact_last_name",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกนามสกุล",
                                                                    value: values.main_contact_last_name,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.main_contact_last_name
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "ชื่อเล่น"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "main_contact_nick_name",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกชื่อเล่น",
                                                                    value: values.main_contact_nick_name,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.main_contact_nick_name
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "อีเมล"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "main_contact_email",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกอีเมล",
                                                                    value: values.main_contact_email,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.main_contact_email
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-4",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "เบอร์โทรศัพท์"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "main_contact_phone_number",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกเบอร์โทร",
                                                                    value: values.main_contact_phone_number,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.main_contact_phone_number
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-4",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "เบอร์มือถือ"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "main_contact_mobile_phone_number",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกเบอร์โทร",
                                                                    value: values.main_contact_mobile_phone_number,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.main_contact_mobile_phone_number
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-4",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "ตำแหน่ง"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "main_contact_position",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกตำแหน่ง",
                                                                    value: values.main_contact_position,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.main_contact_position
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "py-3",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-20 fw-bold tc-5 mb-3",
                                                children: "ผู้ติดต่อสำรอง"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row gx-xl-4",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "ชื่อ"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "alternate_contact_first_name",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกชื่อ",
                                                                    value: values.alternate_contact_first_name,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.alternate_contact_first_name
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "นามสกุล"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "alternate_contact_last_name",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกนามสกุล",
                                                                    value: values.alternate_contact_last_name,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.alternate_contact_last_name
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "ชื่อเล่น"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "alternate_contact_nick_name",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกชื่อเล่น",
                                                                    value: values.alternate_contact_nick_name,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.alternate_contact_nick_name
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "อีเมล"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "alternate_contact_email",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกอีเมล",
                                                                    value: values.alternate_contact_email,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.alternate_contact_email
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-4",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "เบอร์โทรศัพท์"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "alternate_contact_phone_number",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกเบอร์โทร",
                                                                    value: values.alternate_contact_phone_number,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.alternate_contact_phone_number
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-4",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "เบอร์มือถือ"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "alternate_contact_mobile_phone_number",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกเบอร์โทร",
                                                                    value: values.alternate_contact_mobile_phone_number,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.alternate_contact_mobile_phone_number
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-4",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: "ตำแหน่ง"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "alternate_contact_position",
                                                                    className: "form-control",
                                                                    placeholder: "กรอกตำแหน่ง",
                                                                    value: values.alternate_contact_position,
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.alternate_contact_position
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-end pb-4 pe-3",
                        children: props.formdisabled === true ? /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-3",
                            onClick: function() {
                                props.setFormdisabled(false);
                            },
                            children: "แก้ไข"
                        }) : /*#__PURE__*/ _jsxs("div", {
                            className: "text-end pt-3 btn-group-control",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function() {
                                        props.resetData();
                                        resetForm();
                                        props.setFormdisabled(true);
                                    },
                                    type: "button",
                                    className: "btn-st-5 me-3",
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var Account = function(_param) {
    var accountData = _param.accountData, setAccountData = _param.setAccountData, props = _object_without_properties(_param, [
        "accountData",
        "setAccountData"
    ]);
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var supID = useParams().supID;
    var _useState = _sliced_to_array(useState(true), 2), checkservicecharge = _useState[0], setCheckservicecharge = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), updateBankIds = _useState1[0], setUpdateBankIds = _useState1[1];
    var schema = yup.object().shape({
        credit_days: yup.number().min(0).max(366),
        dimSupplierBankInformations: yup.array().of(yup.object().shape({
            dim_mst_bank_id: yup.string().required("The bank is required."),
            bank_account_name: yup.string().required("Account name is required."),
            bank_account_number: yup.number().typeError("Account number must be a number.").required("Account number is required."),
            bank_account_branch_name: yup.string().required("Branch name is required."),
            remark: yup.string()
        })).required("At least one bank information is required.")
    });
    var _useState2 = _sliced_to_array(useState({
        accounts: [
            {
                accountID: 1,
                bankID: 1,
                bankName: "xxx",
                accountName: "xxxx",
                accountNumber: "123546456",
                company_branch_name: "-",
                note: "-"
            }
        ]
    }), 2), account = _useState2[0], setAccount = _useState2[1];
    var _useState3 = _sliced_to_array(useState({
        paymentterms: "",
        paymenttype: "",
        checklimit: 1,
        receivedlimit: ""
    }), 2), payment = _useState3[0], setPayment = _useState3[1];
    var _useState4 = _sliced_to_array(useState([
        0,
        0,
        0
    ]), 2), cdisable = _useState4[0], setCDisable = _useState4[1];
    var loadAllMsts = function() {
        dispatch(getAllMstPaymentType());
        dispatch(getAllMstPaymentMethod());
        dispatch(getAllMstBank());
        dispatch(getAllMstPriceCategory());
    };
    var _useState5 = _sliced_to_array(useState([]), 2), optionsMstPaymentType = _useState5[0], setOptionsMstPaymentType = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), optionsMstPaymentMethod = _useState6[0], setOptionsMstPaymentMethod = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), optionsMstPriceCategory = _useState7[0], setOptionsMstPriceCategory = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), optionsMstBank = _useState8[0], setOptionsMstBank = _useState8[1];
    var getAllMstPaymentTypeReducer = useAppSelector(function(state) {
        return state.getAllMstPaymentTypeReducer;
    });
    var getAllMstPaymentMethodReducer = useAppSelector(function(state) {
        return state.getAllMstPaymentMethodReducer;
    });
    var getAllMstBankReducer = useAppSelector(function(state) {
        return state.getAllMstBankReducer;
    });
    var getAllMstPriceCategoryReducer = useAppSelector(function(state) {
        return state.getAllMstPriceCategoryReducer;
    });
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstPaymentTypeReducer.isFetching || getAllMstPaymentMethodReducer.isFetching || getAllMstBankReducer.isFetching || getAllMstPriceCategoryReducer.isFetching);
        if (getAllMstPaymentTypeReducer.data) {
            var options = mapMstToOptions(getAllMstPaymentTypeReducer.data.data);
            setOptionsMstPaymentType(_to_consumable_array(options));
        }
        if (getAllMstPaymentMethodReducer.data) {
            var options1 = mapMstToOptions(getAllMstPaymentMethodReducer.data.data);
            setOptionsMstPaymentMethod(_to_consumable_array(options1));
        }
        if (getAllMstBankReducer.data) {
            var options2 = mapMstToOptions(getAllMstBankReducer.data.data);
            setOptionsMstBank(_to_consumable_array(options2));
        }
        if (getAllMstPriceCategoryReducer.data) {
            setOptionsMstPriceCategory(getAllMstPriceCategoryReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
    }, [
        getAllMstPaymentTypeReducer,
        getAllMstPaymentMethodReducer,
        getAllMstBankReducer,
        getAllMstPriceCategoryReducer
    ]);
    useEffect(function() {
        if (supID && accountData && accountData.dimSupplierBankInformations) {
            var deletedBankIds = accountData.dimSupplierBankInformations.filter(function(v) {
                return v.id;
            }).map(function(v) {
                return v.id;
            });
            setUpdateBankIds(deletedBankIds);
        }
    }, [
        supID,
        accountData
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-1 mb-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body p-4",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "tc-5 fs-22 mb-4 fw-bold ",
                            children: "ข้อมูลธนาคารของคู่ค้า (สูงสุด 3 บัญชี)"
                        }),
                        /*#__PURE__*/ _jsx(Formik, {
                            enableReinitialize: true,
                            initialValues: accountData,
                            validationSchema: schema,
                            onSubmit: function(values) {
                                var formdataPayload = new FormData();
                                for(var key in values){
                                    if (Object.hasOwnProperty.call(values, key)) {
                                        var value = values[key];
                                        if (Array.isArray(value) && key === "dimSupplierBankInformations") {
                                            formdataPayload.append("dim_supplier_bank_informations", JSON.stringify(value.filter(function(v) {
                                                return !v.id;
                                            })));
                                        } else if (key === "update_bank_objs" && value) {
                                            formdataPayload.append(key, JSON.stringify(value));
                                        } else if (Array.isArray(value)) {
                                            formdataPayload.append(key, JSON.stringify(value));
                                        } else if (value !== undefined) {
                                            formdataPayload.append(key, value);
                                        }
                                    }
                                }
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = formdataPayload.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var pair = _step.value;
                                        var _pair__name;
                                        console.log("".concat(pair[0], ", ").concat((_pair__name = pair[1].name) !== null && _pair__name !== void 0 ? _pair__name : pair[1]));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (supID) {
                                    dispatch(updateSupplierInformation(supID, formdataPayload, {
                                        modalObj: modalObj,
                                        setModalObj: setModalObj
                                    }));
                                }
                            },
                            children: function(param) {
                                var handleSubmit = param.handleSubmit, handleChange = param.handleChange, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, resetForm = param.resetForm;
                                return /*#__PURE__*/ _jsxs(Form, {
                                    noValidate: true,
                                    onSubmit: function(e) {
                                        e.preventDefault();
                                        if (values && values.dimSupplierBankInformations) {
                                            setFieldValue("update_bank_objs", values.dimSupplierBankInformations.filter(function(v) {
                                                return v.id;
                                            }));
                                            setFieldValue("update_bank_ids", updateBankIds.filter(function(bankId) {
                                                return !values.dimSupplierBankInformations.some(function(bank) {
                                                    return bank.id === bankId;
                                                });
                                            }));
                                        }
                                        handleSubmit();
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("fieldset", {
                                            disabled: props.formdisabled,
                                            children: /*#__PURE__*/ _jsx(FieldArray, {
                                                name: "dimSupplierBankInformations",
                                                render: function(arrayHelpers) {
                                                    return /*#__PURE__*/ _jsxs("div", {
                                                        children: [
                                                            values && values.dimSupplierBankInformations.length > 0 ? values.dimSupplierBankInformations.map(function(item, index) {
                                                                return /*#__PURE__*/ _jsxs("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "tc-5 fs-18 mb-2 fw-bold ",
                                                                            children: [
                                                                                "บัญชีที่ ",
                                                                                index + 1
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "row",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("fieldset", {
                                                                                    className: "col",
                                                                                    disabled: cdisable[index],
                                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                                        className: "row ",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                                className: "col",
                                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                            className: "mb-1",
                                                                                                            children: "ธนาคาร"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                                            as: "select",
                                                                                                            name: "dimSupplierBankInformations[".concat(index, "].dim_mst_bank_id"),
                                                                                                            placeholder: "เลือกธนาคาร",
                                                                                                            onChange: function(e) {
                                                                                                                setFieldValue("dimSupplierBankInformations[".concat(index, "].dim_mst_bank_id"), e.value);
                                                                                                            },
                                                                                                            className: "w-100 select-st-1",
                                                                                                            options: optionsMstBank,
                                                                                                            value: optionsMstBank.filter(function(d) {
                                                                                                                return d.value == item.dim_mst_bank_id;
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                                className: "col",
                                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                            className: "mb-1",
                                                                                                            children: "ชื่อบัญชี"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                            type: "text",
                                                                                                            name: "dimSupplierBankInformations[".concat(index, "].bank_account_name"),
                                                                                                            className: "form-control",
                                                                                                            placeholder: "กรอกชื่อบัญชี",
                                                                                                            value: item.bank_account_name,
                                                                                                            onChange: handleChange,
                                                                                                            isInvalid: !!errors.dimSupplierBankInformations && !!errors.dimSupplierBankInformations[index] && !!errors.dimSupplierBankInformations[index].bank_account_name
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                                className: "col",
                                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                            className: "mb-1",
                                                                                                            children: "เลขที่บัญชี"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                            type: "number",
                                                                                                            name: "dimSupplierBankInformations[".concat(index, "].bank_account_number"),
                                                                                                            className: "form-control",
                                                                                                            placeholder: "กรอกเลขที่บัญชี",
                                                                                                            value: item.bank_account_number,
                                                                                                            onChange: handleChange,
                                                                                                            isInvalid: !!errors.dimSupplierBankInformations && !!errors.dimSupplierBankInformations[index] && !!errors.dimSupplierBankInformations[index].bank_account_number
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                                className: "col",
                                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                            className: "mb-1",
                                                                                                            children: "ชื่อสาขา"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                            type: "text",
                                                                                                            name: "dimSupplierBankInformations[".concat(index, "].bank_account_branch_name"),
                                                                                                            className: "form-control",
                                                                                                            placeholder: "กรอกชื่อสาขา",
                                                                                                            value: item.bank_account_branch_name,
                                                                                                            onChange: handleChange,
                                                                                                            isInvalid: !!errors.dimSupplierBankInformations && !!errors.dimSupplierBankInformations[index] && !!errors.dimSupplierBankInformations[index].bank_account_branch_name
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                                className: "col",
                                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                            className: "mb-1",
                                                                                                            children: "หมายเหตุ"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                            type: "text",
                                                                                                            name: "dimSupplierBankInformations[".concat(index, "].remark"),
                                                                                                            className: "form-control",
                                                                                                            placeholder: "กรอกหมายเหตุ",
                                                                                                            value: item.remark,
                                                                                                            onChange: handleChange,
                                                                                                            isInvalid: !!errors.dimSupplierBankInformations && !!errors.dimSupplierBankInformations[index] && !!errors.dimSupplierBankInformations[index].remark
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: " col-auto align-self-center",
                                                                                    children: /*#__PURE__*/ _jsx("button", {
                                                                                        type: "button",
                                                                                        className: "btn btn-delete-st-n1",
                                                                                        onClick: function() {
                                                                                            return arrayHelpers.remove(index);
                                                                                        }
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }, index);
                                                            }) : "",
                                                            values.dimSupplierBankInformations.length < 3 ? /*#__PURE__*/ _jsx("button", {
                                                                className: "btn-st-3 btn mt-2",
                                                                type: "button",
                                                                onClick: function() {
                                                                    arrayHelpers.push({
                                                                        dim_mst_bank_id: "",
                                                                        bank_account_name: "",
                                                                        bank_account_number: "",
                                                                        bank_account_branch_name: "",
                                                                        remark: ""
                                                                    });
                                                                },
                                                                children: "+ บัญชี"
                                                            }) : ""
                                                        ]
                                                    });
                                                }
                                            })
                                        }),
                                        props.formdisabled === true ? /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            className: "btn-st-3 float-right mx-3",
                                            onClick: function() {
                                                props.setFormdisabled(false);
                                            },
                                            children: "แก้ไข"
                                        }) : /*#__PURE__*/ _jsxs("div", {
                                            className: "text-end pt-4 btn-group-control",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    onClick: function() {
                                                        props.resetData();
                                                        resetForm();
                                                        props.setFormdisabled(true);
                                                    },
                                                    type: "button",
                                                    className: "btn-st-5 me-3",
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-st-3 ",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-1",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body p-4",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "tc-5 fs-22 mb-4 fw-bold ",
                            children: "ตั้งค่าการชำระเงิน"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "tc-5 fs-18 mb-3 fw-bold ",
                            children: "การซื้อ"
                        }),
                        /*#__PURE__*/ _jsx(Formik, {
                            enableReinitialize: true,
                            initialValues: accountData,
                            validationSchema: schema,
                            onSubmit: function(values) {
                                var _loop = function(key) {
                                    if (Object.hasOwnProperty.call(values, key)) {
                                        var value = values[key];
                                        if (Array.isArray(value)) {
                                            value.forEach(function(item) {
                                                return formdataPayload.append(key, item);
                                            });
                                        } else if (value !== undefined && value !== "") {
                                            formdataPayload.append(key, value);
                                        }
                                    }
                                };
                                var formdataPayload = new FormData();
                                for(var key in values)_loop(key);
                                // for (let pair of formdataPayload.entries()) {
                                //   console.log(`${pair[0]}, ${pair[1].name ?? pair[1]}`);
                                // }
                                if (supID) {
                                    dispatch(updateSupplierInformation(supID, formdataPayload, {
                                        modalObj: modalObj,
                                        setModalObj: setModalObj
                                    }));
                                }
                            },
                            children: function(param) {
                                var handleSubmit = param.handleSubmit, handleChange = param.handleChange, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, resetForm = param.resetForm;
                                return /*#__PURE__*/ _jsxs(Form, {
                                    noValidate: true,
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "row ",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-3",
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "เงื่อนไขการชำระเงิน"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Select, {
                                                                as: "select",
                                                                name: "dim_mst_payment_type_id",
                                                                placeholder: "เลือกเงื่อนไขการชำระเงิน",
                                                                onChange: function(e) {
                                                                    setFieldValue("dim_mst_payment_type_id", e.value);
                                                                },
                                                                className: "w-100 select-st-1",
                                                                options: optionsMstPaymentType,
                                                                value: optionsMstPaymentType.filter(function(d) {
                                                                    return d.value == values.dim_mst_payment_type_id;
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                values.dim_mst_payment_type_id == 2 && /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-3",
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "จำนวนวัน (0-366)"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "number",
                                                                name: "credit_days",
                                                                className: "form-control ",
                                                                placeholder: "",
                                                                value: values.credit_days,
                                                                onChange: handleChange,
                                                                isInvalid: !!errors.credit_days
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-3",
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 pb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ประเภทราคา"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Select, {
                                                                as: "select",
                                                                name: "dim_mst_price_category_id",
                                                                onChange: function(e) {
                                                                    setFieldValue("dim_mst_price_category_id", e.value);
                                                                },
                                                                className: "w-100 select-st-1 ".concat(values.dim_mst_price_category_id ? "" : !!errors.dim_mst_price_category_id ? "is-invalid" : ""),
                                                                options: optionsMstPriceCategory,
                                                                placeholder: "เลือกประเภทราคา",
                                                                value: optionsMstPriceCategory.filter(function(item) {
                                                                    return item.value === values.dim_mst_price_category_id;
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "col-12 py-3 d-flex",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Check, {
                                                            type: "switch",
                                                            id: "custom-switch",
                                                            label: "",
                                                            name: "is_credit_limit",
                                                            className: "custom-switch-st-1 mt-1",
                                                            onChange: function(e) {
                                                                setFieldValue("is_credit_limit", e.target.checked);
                                                            },
                                                            checked: values.is_credit_limit
                                                        }),
                                                        /*#__PURE__*/ _jsx("label", {
                                                            htmlFor: "custom-switch",
                                                            className: "tc-5 fs-18 fw-bold ",
                                                            children: "วงเงินเครดิต"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 col-xl-6 pb-1  ",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "วงเงินที่ได้รับ "
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "number",
                                                            name: "received_credit_limit",
                                                            className: "form-control ",
                                                            placeholder: "",
                                                            value: values.received_credit_limit,
                                                            onChange: handleChange,
                                                            isInvalid: !!errors.received_credit_limit,
                                                            disabled: !values.is_credit_limit
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "text-end pt-5 btn-group-control",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    onClick: function() {
                                                        props.resetData();
                                                        resetForm();
                                                        props.setFormdisabled(true);
                                                    },
                                                    type: "button",
                                                    className: "btn-st-5 me-3",
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-st-3 ",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var Document = function(_param) {
    var formdata = _param.formdata, setFormdata = _param.setFormdata, props = _object_without_properties(_param, [
        "formdata",
        "setFormdata"
    ]);
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var supID = useParams().supID;
    var _useState = _sliced_to_array(useState([]), 2), documents = _useState[0], setDocuments = _useState[1];
    var addDocument = function() {
        var newId = nanoid();
        setDocuments(function(doc) {
            return _to_consumable_array(doc).concat([
                {
                    id: newId,
                    docId: "",
                    docType: "",
                    docFile: "",
                    docFileType: "",
                    docFileData: "",
                    docUrl: ""
                }
            ]);
        });
    };
    var deleteDocument = function(removeId) {
        setDocuments(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
    };
    var loadAllMsts = function() {
        dispatch(getAllMstSupplierDoc());
    };
    var _useState1 = _sliced_to_array(useState([]), 2), optionsMstSupplierDoc = _useState1[0], setOptionsMstSupplierDoc = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), updateDocIds = _useState2[0], setUpdateDocIds = _useState2[1];
    var getAllMstSupplierDocReducer = useAppSelector(function(state) {
        return state.getAllMstSupplierDocReducer;
    });
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstSupplierDocReducer.isFetching);
        if (getAllMstSupplierDocReducer.data) {
            var options = mapMstToOptions(getAllMstSupplierDocReducer.data.data);
            setOptionsMstSupplierDoc(_to_consumable_array(options));
        }
    }, [
        getAllMstSupplierDocReducer
    ]);
    useEffect(function() {
        if (supID) {
            var docFiles = [];
            if (formdata && formdata.dimSupplierAttachedDocs) {
                var _formdata_dimSupplierAttachedDocs;
                docFiles = (_formdata_dimSupplierAttachedDocs = formdata.dimSupplierAttachedDocs) === null || _formdata_dimSupplierAttachedDocs === void 0 ? void 0 : _formdata_dimSupplierAttachedDocs.map(function(item) {
                    var newId = nanoid();
                    return {
                        id: newId,
                        docId: item.id,
                        docType: item.dim_mst_supplier_doc_id,
                        docFile: getFileName(item.file_path),
                        docFileType: "",
                        docFileData: "",
                        docUrl: getFullUrlPath(item.file_path)
                    };
                });
            }
            console.log(formdata);
            setDocuments(docFiles);
        }
    }, [
        formdata
    ]);
    useEffect(function() {
        if (supID && formdata) {
            var deleteCandidateDocIds = formdata.dimSupplierAttachedDocs ? formdata.dimSupplierAttachedDocs.map(function(item) {
                return item.id;
            }) : [];
            var deleteDocIds = deleteCandidateDocIds.filter(function(docId) {
                return !documents.some(function(doc) {
                    return doc.docId === docId;
                });
            });
            var allDocIds = _to_consumable_array(deleteDocIds);
            console.log("All Doc IDs to update or delete:", allDocIds);
            setUpdateDocIds(allDocIds);
        }
    }, [
        supID,
        documents,
        formdata
    ]);
    return /*#__PURE__*/ _jsx(Formik, {
        enableReinitialize: true,
        onSubmit: function(values) {
            var _loop = function(key) {
                if (Object.hasOwnProperty.call(values, key)) {
                    var value = values[key];
                    if (key === "dim_supplier_attached_docs" && value) {
                        formdataPayload.append(key, JSON.stringify(value));
                    } else if (key === "update_doc_types" && value) {
                        formdataPayload.append(key, JSON.stringify(value));
                    } else if (key === "doc_files" && Array.isArray(value)) {
                        value.forEach(function(base64String, index) {
                            if (base64String) {
                                var blob = base64ToBlob(base64String);
                                formdataPayload.append("".concat(key), blob, "document_".concat(index, ".pdf"));
                            }
                        });
                    } else if (Array.isArray(value)) {
                        value.forEach(function(item) {
                            return formdataPayload.append(key, item);
                        });
                    } else if (value !== undefined && value !== "") {
                        formdataPayload.append(key, value);
                    }
                }
            };
            var formdataPayload = new FormData();
            for(var key in values)_loop(key);
            // for (let pair of formdataPayload.entries()) {
            //   console.log(`${pair[0]}, ${pair[1].name ?? pair[1]}`);
            // }
            if (supID) {
                dispatch(updateSupplierInformation(supID, formdataPayload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        },
        initialValues: _object_spread_props(_object_spread({}, formdata), {
            dim_supplier_attached_docs: [],
            doc_files: []
        }),
        children: function(param) {
            var handleSubmit = param.handleSubmit, values = param.values, setFieldValue = param.setFieldValue, resetForm = param.resetForm;
            return /*#__PURE__*/ _jsxs(Form, {
                noValidate: true,
                onSubmit: function(e) {
                    e.preventDefault();
                    setFieldValue("dim_supplier_attached_docs", documents.filter(function(v) {
                        return !v.docId;
                    }).map(function(v) {
                        return {
                            dim_mst_supplier_doc_id: v.docType
                        };
                    }));
                    setFieldValue("doc_files", documents.map(function(v) {
                        return v.docFileData;
                    }));
                    setFieldValue("update_doc_types", documents.filter(function(v) {
                        return v.docId;
                    }).map(function(v) {
                        return {
                            id: v.docId,
                            dim_mst_supplier_doc_id: v.docType
                        };
                    }));
                    console.log(updateDocIds);
                    setFieldValue("update_doc_ids", JSON.stringify(updateDocIds));
                    handleSubmit();
                },
                children: [
                    /*#__PURE__*/ _jsx("fieldset", {
                        disabled: props.formdisabled,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card-body px-xl-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-22 fw-bold tc-5 mb-3 mt-2",
                                        children: "เอกสารแนบ"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        id: "",
                                        className: "",
                                        children: [
                                            documents.map(function(item, index) {
                                                return /*#__PURE__*/ _jsx(Fileupload, {
                                                    setFieldValue: setFieldValue,
                                                    values: values,
                                                    item: item,
                                                    index: index,
                                                    setDocuments: setDocuments,
                                                    ondeleteDocument: function(id) {
                                                        deleteDocument(id);
                                                    },
                                                    options: optionsMstSupplierDoc
                                                }, index);
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "px-3 py-4",
                                                children: /*#__PURE__*/ _jsx("button", {
                                                    type: "button",
                                                    className: "btn btn-st-4",
                                                    onClick: addDocument,
                                                    children: "เพิ่มเอกสาร"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-end pb-4 pe-3",
                        children: props.formdisabled === true ? /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-3",
                            onClick: function() {
                                props.setFormdisabled(false);
                            },
                            children: "แก้ไข"
                        }) : /*#__PURE__*/ _jsxs("div", {
                            className: "text-end pt-3 btn-group-control",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function() {
                                        props.resetData();
                                        resetForm();
                                        props.setFormdisabled(true);
                                    },
                                    type: "button",
                                    className: "btn-st-5 me-3",
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var Line = function(_param) {
    var connectData = _param.connectData, setConnectData = _param.setConnectData, props = _object_without_properties(_param, [
        "connectData",
        "setConnectData"
    ]);
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var dispatch = useAppDispatch();
    var supID = useParams().supID;
    return /*#__PURE__*/ _jsx(Formik, {
        enableReinitialize: true,
        initialValues: connectData,
        onSubmit: function(values) {
            var formdataPayload = new FormData();
            for(var key in values){
                if (Object.hasOwnProperty.call(values, key)) {
                    var value = values[key];
                    if (value !== undefined && value !== "") {
                        formdataPayload.append(key, value);
                    }
                }
            }
            // for (let pair of formdataPayload.entries()) {
            //   console.log(`${pair[0]}, ${pair[1].name ?? pair[1]}`);
            // }
            dispatch(updateSupplierInformation(supID, formdataPayload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        },
        children: function(param) {
            var handleSubmit = param.handleSubmit, handleChange = param.handleChange, errors = param.errors, values = param.values, resetForm = param.resetForm;
            return /*#__PURE__*/ _jsxs(Form, {
                noValidate: true,
                onSubmit: function(e) {
                    e.preventDefault();
                    handleSubmit();
                },
                children: [
                    /*#__PURE__*/ _jsx("fieldset", {
                        disabled: props.formdisabled,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card-body px-xl-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-22 fw-bold tc-5 mb-5 mt-2",
                                        children: [
                                            "Line Notify Token",
                                            /*#__PURE__*/ _jsxs("span", {
                                                className: "fw-normal",
                                                style: {
                                                    color: "#999999"
                                                },
                                                children: [
                                                    " ",
                                                    "(สำหรับส่งใบสั่งซื้อ)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "row gx-xl-4",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-5",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3 pb-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "Line Token"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        name: "line_token",
                                                        className: "form-control",
                                                        placeholder: "",
                                                        value: values.line_token,
                                                        onChange: handleChange,
                                                        isInvalid: !!errors.line_token
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-end pb-4 pe-3",
                        children: props.formdisabled === true ? /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-3",
                            onClick: function() {
                                props.setFormdisabled(false);
                            },
                            children: "แก้ไข"
                        }) : /*#__PURE__*/ _jsxs("div", {
                            className: "text-end pt-3 btn-group-control",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    onClick: function() {
                                        props.resetData();
                                        resetForm();
                                        props.setFormdisabled(true);
                                    },
                                    type: "button",
                                    className: "btn-st-5 me-3",
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    className: "btn-st-3 ",
                                    children: "บันทึก"
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var Overview = function() {
    var _useState = _sliced_to_array(useState([
        {
            purchaseOrderCode: "24010000001",
            purchaseDate: "30/02/2024",
            dueDate: "30/04/2024",
            cost: "18,000.00",
            period: " 1 วัน"
        },
        {
            purchaseOrderCode: "24010000002",
            purchaseDate: "30/02/2024",
            dueDate: "30/04/2024",
            cost: "18,000.00",
            period: "เลยมา 7 วัน"
        }
    ]), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionsDistributorgroup = _useState1[0], setOptionsDistributorgroup = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), dim_group_of_supplier_id = _useState2[0], setDistributorgroup = _useState2[1];
    var _useState3 = _sliced_to_array(useState(), 2), taxID = _useState3[0], setTaxID = _useState3[1];
    var columns = [
        {
            name: "เลขที่เอกสารใบสั่งซื้อ",
            selector: function(row) {
                return row.purchaseOrderCode;
            },
            width: "170px"
        },
        {
            name: "วันที่สั่งซื้อ",
            selector: function(row) {
                return row.purchaseDate;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.purchaseDate,
                        " "
                    ]
                });
            }
        },
        {
            name: "วันที่กำหนดชำระ",
            selector: function(row) {
                return row.dueDate;
            }
        },
        {
            name: "มูลค่า",
            selector: function(row) {
                return row.cost;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.cost,
                        " "
                    ]
                });
            }
        },
        {
            name: "ครบกำหนดอีก",
            selector: function(row) {
                return row.period;
            },
            center: true,
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "",
                    style: {
                        color: "#F26F3A"
                    },
                    children: row.period
                });
            }
        }
    ];
    var _useState4 = _sliced_to_array(useState(""), 2), filterText = _useState4[0], setFilterText = _useState4[1];
    var filteredItems = tabledata.filter(function(item) {
        return item.purchaseOrderCode && item.purchaseOrderCode.toLowerCase().includes(filterText.toLowerCase());
    });
    if (dim_group_of_supplier_id.value != "") {
        filteredItems = filteredItems.filter(function(item) {
            return item.distributorGroup == dim_group_of_supplier_id.label;
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-1 mb-5",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card-body px-xl-4 pt-4 pb-0 ",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "row  col-border",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-xxl mb-4 col-xl-3 col-md-6",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-22 fw-bold tc-14 mb-3",
                                        children: "วันที่ชำระเงินเฉลี่ย"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-22 fw-bold mb-3",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-5 me-3",
                                                children: "13"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-14 ",
                                                children: "วัน"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tc-14",
                                        children: "เฉลี่ยจาก 10 ใบแจ้งหนี้หรือใบลวางบิลล่าสุด"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-xxl mb-4 col-xl-3 col-md-6",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-22 fw-bold tc-14 mb-3",
                                        children: "ยอดซื้อสะสมรายปี"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-22 fw-bold mb-3",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-5 me-3",
                                                children: "21,000"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-14 ",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "tc-14",
                                        children: [
                                            "ยอดซื้อสะสมรอบปี",
                                            " ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-1",
                                                children: "1 ม.ค 2024 - 31 ธ.ค 2024"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-xxl mb-4 col-xl-3 col-md-6",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-22 fw-bold tc-14 mb-3",
                                        children: "ยอดซื้อสะสม"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-22 fw-bold mb-3",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-5 me-3",
                                                children: "79,000.00"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-14 ",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tc-14",
                                        children: "ยอดซื้อสะสมตลอดระเวลาที่สั่งซื้อ"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-xxl mb-4 col-xl-3 col-md-6",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-22 fw-bold tc-14 mb-3",
                                        children: "วงเงินเชื่อ"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-14",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-14  me-2",
                                                children: "ใช้ไป"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-5",
                                                children: "21,000.00"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            maxWidth: "300px"
                                        },
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "progress my-2",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "progress-bar",
                                                role: "progressbar",
                                                style: {
                                                    width: "25%"
                                                },
                                                "aria-valuenow": "25",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "fs-14",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-14",
                                                children: "วงเงิน "
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-5 mx-2",
                                                children: "50,000.00"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-14",
                                                children: "บาท เหลือ"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-5 mx-2",
                                                children: "39,000.00"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "tc-14",
                                                children: "บาท"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-xxl mb-4 col-xl-3 col-md-6",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-22 fw-bold tc-14 mb-3",
                                        children: "สถิติการสั่งซื้อ"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex mb-1 fs-14",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tc-14",
                                                style: {
                                                    width: "140px"
                                                },
                                                children: "คำสั่งซื้อครั้งแรก"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tc-5",
                                                children: "1 ม.ค 2020"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex mb-1 fs-14",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tc-14",
                                                style: {
                                                    width: "140px"
                                                },
                                                children: "คำสั่งซื้อล่าสุด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tc-5",
                                                children: "20 ธ.ค 2023"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex fs-14",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tc-14",
                                                style: {
                                                    width: "140px"
                                                },
                                                children: "ระยะเวลาคู่ค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tc-5",
                                                children: "4 ปี 2เดือน"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row ",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-7",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-1 mb-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body px-xl-2 pt-4 pb-0 ",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tc-14 fs-22 px-3 mb-3 fw-bold ",
                                        children: "ข้อมูลการสั่งซื้อ"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex align-items-center px-4 mb-0 flex-wrap",
                                        children: [
                                            /*#__PURE__*/ _jsx(DownloadExcel, {
                                                data: filteredItems,
                                                filename: "ผู้จัดจำหน่าย"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mb-2 me-3",
                                                style: {
                                                    width: "180px"
                                                },
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "form-st-3 sm pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "กลุ่มผู้จัดจำหน่าย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Select, {
                                                            as: "select",
                                                            name: "",
                                                            onChange: function(e) {
                                                                setDistributorgroup(e);
                                                            },
                                                            className: "w-100 select-st-1",
                                                            options: optionsDistributorgroup,
                                                            placeholder: "",
                                                            value: dim_group_of_supplier_id
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "me-3 mb-2",
                                                children: /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control form-st-4",
                                                    placeholder: "ค้นหาเลขที่,ชื่อผู้จำหน่าย",
                                                    onKeyUp: function(e) {
                                                        return setFilterText(e.target.value);
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "px-3",
                                        children: /*#__PURE__*/ _jsx(DataTableLayout, {
                                            item: filteredItems,
                                            columns: columns,
                                            isSelectRows: true,
                                            PerPage: 10
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-5",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-1 mb-4",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "card-body px-xl-2 pt-4 pb-0 ",
                                children: /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        height: "500px"
                                    }
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var Imageupload = function(_param) {
    var isUpdate = _param.isUpdate, props = _object_without_properties(_param, [
        "isUpdate"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), imgData = _useState[0], setImgData = _useState[1];
    var handlePreviewimage = function(e) {
        if (e.target.files[0]) {
            var reader = new FileReader();
            reader.addEventListener("load", function() {
                setImgData(reader.result);
                props.setFieldValue("img_file", reader.result);
                if (isUpdate) {
                    props.setFieldValue("is_update_img_file", true);
                }
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    useEffect(function() {
        setImgData(props.values.img_path ? getFullUrlPath(props.values.img_path) : false);
    }, [
        props.values.img_path
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "d-flex align-items-center mb-4 mt-3 ",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "bx-upload",
                children: imgData ? /*#__PURE__*/ _jsx("img", {
                    src: imgData
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "preimg"
                })
            }),
            /*#__PURE__*/ _jsx("input", {
                type: "file",
                name: "",
                className: "fileUpload hide-input",
                id: "fileUpload",
                accept: "image/*",
                onChange: function(e) {
                    handlePreviewimage(e);
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex-fill ms-3",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn btn-st-4 btn-upload me-3",
                                onClick: function() {
                                    return document.getElementById("fileUpload").click();
                                },
                                children: "อัปโหลดรูปภาพ"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn btn-st-2 btn-remove-image",
                                onClick: function() {
                                    setImgData(false);
                                    props.setFieldValue("img_file", "");
                                    if (isUpdate) {
                                        props.setFieldValue("is_update_img_file", true);
                                    }
                                },
                                children: "ลบ"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "tc-7 fs-12",
                        children: "อัพโหลดไฟล์ JPG, GIF or PNG. ขนาดไม่เกิน 800K"
                    })
                ]
            })
        ]
    });
};
function TaxIDModal(_param) {
    var distributorData = _param.distributorData, setDistributorData = _param.setDistributorData, props = _object_without_properties(_param, [
        "distributorData",
        "setDistributorData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var _useState = _sliced_to_array(useState([]), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), taxID = _useState1[0], setTaxID = _useState1[1];
    var _useState2 = _sliced_to_array(useState([
        {
            tax_identification_number: "0565556000251",
            company_name: "บริษัท อินเตอร์ คอฟฟี่เทรด จำกัด",
            businessAddress: "19/7 ถนน ฟากน้ำ ตำบล แม่ต่ำ อำเภอ เมืองพะเยา จังหวัด พะเยา 56000",
            company_branch_name: "สำนักงานใหญ่"
        }
    ]), 2), data = _useState2[0], setData = _useState2[1];
    var handleClick = function(val) {
        setDistributorData(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                tax_identification_number: val.tax_identification_number,
                company_name: val.company_name,
                company_branch_name: val.company_branch_name,
                company_address: val.businessAddress,
                dim_mst_business_type_id: 2
            });
        });
        props.onHide();
    };
    var columns = [
        {
            name: "เลขผู้เสียภาษี",
            selector: function(row) {
                return row.tax_identification_number;
            },
            width: "170px"
        },
        {
            name: "ชื่อบริษัท",
            selector: function(row) {
                return row.company_name;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.company_name,
                        " "
                    ]
                });
            },
            width: "200px"
        },
        {
            name: "สาขา",
            selector: function(row) {
                return row.company_branch_name;
            },
            width: "170px"
        },
        {
            name: "ที่อยู่",
            selector: function(row) {
                return row.businessAddress;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.businessAddress,
                        " "
                    ]
                });
            }
        },
        {
            name: "ตัวเลือก",
            selector: function(row) {
                return row.tax_identification_number;
            },
            center: true,
            width: "120px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    className: " btn-st-3",
                    onClick: function() {
                        return handleClick(row);
                    },
                    children: "เลือก"
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, rest), {
        size: "xl",
        centered: true,
        children: /*#__PURE__*/ _jsxs(Modal.Body, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center px-3 py-2 mb-4 pb-3",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-24 fw-bold me-auto",
                            style: {
                                color: "rgba(76, 78, 100, 0.87)"
                            },
                            children: "ค้นหาข้อมูลจากฐานข้อมูลกรมสรรพากร"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            onClick: props.onHide,
                            className: "btn btn-close-modal"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: " px-3 d-flex align-items-center mb-3",
                    children: [
                        /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3   pb-1",
                            style: {
                                width: "400px"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "เลขที่ประจำตัวผู้เสียภาษี"
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    type: "number",
                                    name: "tax_identification_number",
                                    className: "form-control",
                                    placeholder: "เลขที่ประจำตัวผู้เสียภาษี",
                                    value: taxID,
                                    onChange: function(e) {
                                        return setTaxID(e.target.value);
                                    },
                                    maxLength: 13
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-3 ms-3 me-auto py-2 fs-18 px-2",
                            onClick: function() {
                                return setTabledata(data);
                            },
                            children: "ค้นหาจาก TAX ID"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                "ผลการค้นหา ",
                                /*#__PURE__*/ _jsx("span", {
                                    children: tabledata.length
                                }),
                                " รายการ"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "px-3",
                    children: /*#__PURE__*/ _jsx(DataTableLayout, {
                        item: tabledata,
                        columns: columns,
                        isSelectRows: false,
                        PerPage: 10
                    })
                })
            ]
        })
    }));
}
var Fileupload = function(param) {
    var item = param.item, index = param.index, values = param.values, ondeleteDocument = param.ondeleteDocument, setDocuments = param.setDocuments, options = param.options;
    var _useState = _sliced_to_array(useState(false), 2), filedata = _useState[0], setFiledata = _useState[1];
    var files = item.docFile.split(".");
    var handlePreviewFile = function(e) {
        if (e.target.files[0]) {
            var reader = new FileReader();
            var file = e.target.files[0].name.split(".");
            var blobUrl = URL.createObjectURL(e.target.files[0]);
            reader.addEventListener("load", function() {
                setDocuments(function(prev) {
                    return prev.map(function(el) {
                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                            docFile: e.target.files[0].name,
                            docFileType: file[1],
                            docFileData: reader.result,
                            docUrl: blobUrl
                        }) : el;
                    });
                });
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "px-3",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-xl-4 align-items-center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "fs-24 fw-bold tc-8",
                        children: [
                            index + 1,
                            "."
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-xxl-2 col-xl-3 col-md-4 ",
                    children: [
                        /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "เอกสาร"
                                }),
                                /*#__PURE__*/ _jsx(Select, {
                                    as: "select",
                                    name: "doc",
                                    onChange: function(e) {
                                        setDocuments(function(prev) {
                                            return prev.map(function(el) {
                                                return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                    docType: e.value
                                                }) : el;
                                            });
                                        });
                                    },
                                    className: "w-100 select-st-1",
                                    options: options,
                                    placeholder: "",
                                    value: options.filter(function(d) {
                                        return d.value == item.docType;
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("input", {
                            type: "file",
                            name: "",
                            className: "fileUpload hide-input",
                            id: "fileUpload".concat(item.id),
                            accept: ".pdf",
                            onChange: function(e) {
                                handlePreviewFile(e);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: "180px"
                        },
                        children: item.docFile != "" ? /*#__PURE__*/ _jsx("a", {
                            href: "".concat(item.docUrl),
                            target: "_blank",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "docfile",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon ".concat(files[1])
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "name fs-18",
                                        children: files[0]
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn  btn-upload-file",
                            onClick: function() {
                                return document.getElementById("fileUpload".concat(item.id)).click();
                            },
                            children: "อัปโหลดรูปภาพ"
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: "btn  btn-delete-file ",
                        onClick: function() {
                            return ondeleteDocument(item.id);
                        }
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col"
                })
            ]
        })
    });
};
